import 'flatpickr/dist/l10n'

document.addEventListener('DOMContentLoaded', displayError);
document.addEventListener('DOMContentLoaded', loadVcardView);
document.addEventListener('DOMContentLoaded', passwordLoad);
document.addEventListener('DOMContentLoaded', langDropdown);
function displayError (selector, msg) {
    let selectorAttr = $(selector);
    selectorAttr.removeClass('d-none');
    selectorAttr.show();
    selectorAttr.text(msg);
    setTimeout(function () {
        $(selector).slideUp();
    }, 3000);
}
let selectedDate;
let selectedSlotTime;
let timezone_offset_minutes;
function loadVcardView(){
    let urlStr = window.location.href
    if(urlStr.indexOf('?')!=-1) {
        window.history.pushState(null, '', route('vcard.show', vcardAlias))
        let message = urlStr.split('?').pop();
        displaySuccessMessage(message.replace(/%20/g, ' '))
    }
    if(!$('.date').length){
        return
    }
    timezone_offset_minutes = new Date().getTimezoneOffset();
    timezone_offset_minutes = timezone_offset_minutes === 0
        ? 0
        : -timezone_offset_minutes;

    $('.date').flatpickr({
        "locale": lang,
        minDate: new Date(),
        disableMobile: true,
    })

    setTimeout(function () {
        if (isEdit) {
            $('.date').val(date).trigger('change');
        }
    }, 1000);
    if (!$('.no-time-slot').length) {
        return;
    }
    $('.no-time-slot').removeClass('d-none');
}

function langDropdown(){
    if(!$('.dropdown1').length){
        return
    }
    $('.dropdown1').hover(function () {
        $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn(100);
    }, function () {
        $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut(100);
    });
}
listenClick('#languageName', function () {
    let languageName = $(this).attr('data-name');
    $.ajax({
        url: languageChange + '/' + languageName + '/' + vcardAlias,
        type: 'GET',
        success: function (result) {
            displaySuccessMessage(result.message)
            setTimeout(function () {
                location.reload();
            }, 2000);
        },
        error: function error (result) {
            displayErrorMessage(result.responseJSON.message);
        },
    });
});

$(window).resize(function () {
    if ($(window).width() < 1025) {
        $('.vcard11-referral-text').addClass('d-none')
        $('.vcard11-referral-icon').removeClass('me-2')
    } else {
        $('.vcard11-referral-text').removeClass('d-none')
        $('.vcard11-referral-icon').addClass('me-2')
    }
})
$(window).trigger('resize')

function passwordLoad () {
    if (password) {
        let passwordAttr = $('#passwordModal')
        passwordAttr.appendTo('body').modal('show')
    } else {
        $('.content-blur').removeClass('content-blur')
    }
}
listenHiddenBsModal('#passwordModal', function () {
    $(this).find('#password').focus();
});

listenSubmit('#passwordForm', function (event) {
    event.preventDefault();
    $.ajax({
        url: passwordUrl,
        type: 'POST',
        data: $(this).serialize(),
        success: function (result) {
            if (result.success) {
                $('#passwordModal').modal('hide');
                location.reload();
                $('.content-blur').removeClass('content-blur');
            }
        },
        error: function (result) {
            displayError('#passwordError', result.responseJSON.message);
        },
    });
});
listenSubmit('#mailSendForm', function (event) {
    event.preventDefault();
    $('.loadspin').removeClass('d-none');
    $('.contact-btn').prop('disabled', true);
    $.ajax({
        url: enquiryUrl,
        type: 'POST',
        data: $(this).serialize(),
        success: function (result) {
            $('#mailSendSuccess').modal('show');
            $('#mailSendForm')[0].reset();
            $('.loadspin').addClass('d-none');
            $('.contact-btn').prop('disabled', false);
            grecaptcha.reset();
        },
        error: function (result) {
            displayError('#mailSendError', result.responseJSON.message);
            $('.contact-btn').prop('disabled', false);
            $('.loadspin').addClass('d-none');
            grecaptcha.reset();
        },
    });
});

listenClick('.vcard-share', function () {
    $('#vcard-shareModal').modal('show');
});
listenClick('.share', function () {
    $('#vcard-shareModal').modal('hide');
});
listenClick('.vcard-add', function () {
    $('#vcard-addModal').modal('show');
});
listenClick('.add', function () {
    $('#vcard-addModal').modal('hide');
});
listenClick('.vcard-qrd', function () {
    $('#vcard-qrdModal').modal('show');
});
listenClick('.qrd', function () {
    $('#vcard-qrdModal').modal('hide');
});
listenClick('.vcard-dis', function () {
    $('#vcard-disModal').modal('show');
});
listenClick('.vcard-terms', function () {
    $('#vcard-termsModal').modal('show');
});

listenClick('.gallery-link', function () {
    let ytlink = $(this).data('id');
    $('#video').attr('src', '//www.youtube.com/embed/'+ytlink);
});
listenHiddenBsModal('#galleryModal', function () {
    $('#video').attr('src', '');
});
listen('click', '.paymentByPaypal', function () {

    let campaignId = $('#campaignId').val()
    let firstName = $('#firstName').val()
    let LastName = $('#lastName').val()
    let email = $('#email').val()
    let currencyCode = $('#currencyCode').val()
    let amount = $('#amount').val()

    if (amount.trim().length === 0) {
        iziToast.error({
            title: 'Error',
            message: 'The amount field is required',
            position: 'topRight',
        })

        return false
    } else if (amount === '0') {
        iziToast.error({
            title: 'Error',
            message: 'The amount is required greater than zero',
            position: 'topRight',
        })

        return false
    } else if (firstName.trim().length === 0) {
        iziToast.error({
            title: 'Error',
            message: 'The first name field is required',
            position: 'topRight',
        })

        return false
    } else if (LastName.trim().length === 0) {
        iziToast.error({
            title: 'Error',
            message: 'The last name field is required',
            position: 'topRight',
        })

        return false
    }

    $(this).addClass('disabled')
    $('.donate-btn').text('Please Wait...')

    $.ajax({
        type: 'GET',
        url: route('paypal.init'),
        data: {
            amount: parseFloat($('#amount').val()),
            currency_code: $('#currencyCode').val(),
            campaign_id: campaignId,
            first_name: firstName,
            last_name: LastName,
            email: email,
        },
        success: function (result) {
            if (result.link) {
                window.location.href = result.link
            }

            if (result.statusCode === 201) {
                let redirectTo = ''

                $.each(result.result.links,
                    function (key, val) {
                        if (val.rel == 'approve') {
                            redirectTo = val.href
                        }
                    })
                location.href = redirectTo
            }
        },
        error: function (error) {
            iziToast.error({
                title: 'Error',
                message: error.responseJSON.message,
                position: 'topRight',
            })
        },
        complete: function () {
        },
    })
})

// $(document).ready(function() {
// Configure/customize these variables.
var showChar = 80  // How many characters are shown by default
var ellipsestext = '....'
var moretext = '&#9662;'
var lesstext = '&#9651;'

$('.more').each(function () {
    var content = $(this).html()

    if (content.length > showChar) {

        var c = content.substr(0, showChar)
        var h = content.substr(showChar, content.length - showChar)

        var html = c + '<span class="moreellipses">' + ellipsestext +
            '&nbsp;</span><span class="morecontent"><span>' + h +
            '</span>&nbsp;&nbsp;<button class="morelink text-decoration-none fw-bold">' +
            moretext + '</button></span>'

        $(this).html(html)
    }

})

$('.morelink').click(function () {
    if ($(this).hasClass('less')) {
        $(this).removeClass('less')
        $(this).html(moretext)
    } else {
        $(this).addClass('less')
        $(this).html(lesstext)
    }
    $(this).parent().prev().toggle()
    $(this).prev().toggle()
    return false
})

$('.next-arrow , .prev-arrow').click(function () {
    $('.morelink').removeClass('less')
    $('.morelink').html(moretext)
    $('.morecontent span').css('display', 'none')
})

$('.testimonial-slider, .testimonials-section, .testimonial-box').
    on('swipe', function () {
        $('.morelink').removeClass('less')
        $('.morelink').html(moretext)
        $('.morecontent span').css('display', 'none')
    })

$('.testimonials-section, .testimonial-box, .testimonial-card, .testimonial-vcard').
    on('beforeChange', function () {
        $('.morelink').removeClass('less')
        $('.morelink').html(moretext)
        $('.morecontent span').css('display', 'none')
    })
